import ApiConfig from '../app_config/apiConfig';
import UtilityService from './utilityService';
import Store from '../store/store';
import authorize from './authorize';
import authService from './authService';
import { SHOW_API_ERROR } from '../constants/reducerTypes';

class HttpAPI {
  constructor() {
    this.baseUrl = ApiConfig.baseUrl[process.env.REACT_APP_ENVIRONMENT_NAME]
      ? ApiConfig.baseUrl[process.env.REACT_APP_ENVIRONMENT_NAME]
      : ApiConfig.baseUrl.prod;
  }

  // =====================
  // Function to prepare http requests list
  // return async function
  // =====================
  requestApi = async (config, hideLoader, cancelAuthCheck, loopCounter) => {
    let loopCounterVal = 1;
    if (loopCounter !== undefined && loopCounter !== null) loopCounterVal = loopCounter;
    if (authService.refreshingPromise) {
      await authService.refreshingPromise;
    }
    if (loopCounterVal <= 5) {
      let apiUrl;
      let requestBody;
      let httpRequest = [];

      if (!cancelAuthCheck) {
        await this.authenticationCheck();
      }

      config.forEach(apiData => {
        const reqHeaders = new window.Headers(ApiConfig.header);
        if (apiData.api.header && Object.keys(apiData.api.header).length > 0) {
          Object.keys(apiData.api.header).forEach(headerKey => {
            reqHeaders.set(headerKey, apiData.api.header[headerKey]);
          });
        }
        const { isMDWRequest, isDPF, isTDS, endPointUrl, teamK } = apiData.api;
        const authData = Store.getState().authenticationData
          ? Store.getState().authenticationData.userDetails
          : {};
        const { spoToken, accountId, mdwToken, dpfToken, tdsToken } = authData;
        const requestAccessToken = apiData.api.tokenId
          ? authData[`${apiData.api.tokenId}`]
          : authData.accessToken;
        reqHeaders.set('Authorization', `Bearer ${requestAccessToken}`);
        reqHeaders.set('Strict-Transport-Security', 'max-age=31536000; includeSubDomains');
        if (accountId) {
          reqHeaders.set('AccountId', accountId);
        }

        if (isMDWRequest && mdwToken) {
          reqHeaders.set('MDWAuthorization', mdwToken);
        } else if (isDPF) {
          reqHeaders.set('endpoint', endPointUrl);
          reqHeaders.set('DpfAuthorization', dpfToken);
          if (teamK !== undefined) reqHeaders.set('teamK', teamK);
        } else if (isTDS) {
          reqHeaders.set('TdsAuthorization', tdsToken);
        } else {
          reqHeaders.set('SPOAuthorization', spoToken);
        }

        const apiBaseUrl = apiData.api.baseUrl ? apiData.api.baseUrl : this.baseUrl;
        apiUrl = apiData.api.endpoint ? apiBaseUrl + apiData.api.endpoint : apiBaseUrl;
        requestBody = apiData.api.data ? JSON.stringify(apiData.api.data) : null;
        httpRequest = [
          ...httpRequest,
          new window.Request(apiUrl, {
            method: apiData.api.method,
            body: requestBody,
            headers: reqHeaders,
          }),
        ];
      });
      return this.executeFetch(httpRequest, hideLoader, config, loopCounterVal);
    }
    // eslint-disable-next-line no-else-return
    else {
      authorize.acquireTokenWithRetry();
      throw new Error('Maximum API request completed');
    }
  };

  // =====================
  // Function to execute HTTP requests
  // =====================
  executeFetch = async (request, hideLoader, config, loopCounter) => {
    let resData;
    const loopCounterVal = loopCounter + 1;
    if (!hideLoader) {
      UtilityService.manageLoader(true);
    }
    try {
      const promises = request.map(element =>
        window.fetch(element).then(res => {
          if (!res.ok) {
            return res;
          }
          if (
            res.headers.get('Content-Type') === 'image/jpeg' ||
            res.headers.get('Content-Type') === 'text/plain'
          ) {
            return res.body;
          }
          return res.json();
        }),
      );
      resData = await Promise.all(promises);
      const errorResponses = Array.isArray(resData)
        ? resData.filter(item => item?.ok === false)
        : [];

      if (errorResponses.length > 0) {
        let unauthorized = false;
        errorResponses.forEach(errorItem => {
          if (errorItem.status === 401) {
            unauthorized = true;
          }
          else if(errorItem.status >= 500){
            console.log("endpoint failed 500 retrying ",loopCounterVal,);
            this.requestApi(config, hideLoader, true, loopCounterVal);
          }
          else {
            const apiUrl = errorItem?.url;
            this.dispatchApiError(errorItem.status?.toString(), apiUrl);
          }
        });
        if (unauthorized) {
          const refreshed = await this.authenticationCheck(true);
          if (refreshed) {
            return this.requestApi(config, hideLoader, true, loopCounterVal);
            // eslint-disable-next-line no-else-return
          } else {
            authorize.acquireTokenWithRetry();
            throw new Error('Session expired. Please login again.');
          }
        }
      }
      return resData;
    } catch (error) {
      UtilityService.manageLoader(false);
      if (error.status === 401 || error.status === 403) {
        const refreshed = await this.authenticationCheck(true);
        if (refreshed) {
          return this.requestApi(config, hideLoader, true, loopCounterVal);
          // eslint-disable-next-line no-else-return
        } else {
          authorize.acquireTokenWithRetry();
          throw new Error('Session expired. Please login again.');
        }
      } else {
        this.dispatchApiError('default');
        throw new Error(error);
      }
    } finally {
      if (!hideLoader) {
        UtilityService.manageLoader(false);
      }
    }
  };

  // =====================
  // Function to validate the token expiry
  // redirect if token expired
  // =====================
  authenticationCheck = async proceedAuthentication => {
    if (proceedAuthentication || UtilityService.checkTokenExpiry()) {
      localStorage.clear();
      window.sessionStorage.removeItem('cartCompareData');
      const refresh = await authService.refreshToken();
      return refresh;
    }
    return true;
  };

  dispatchApiError = (errorCode, apiUrl = null) => {
    const errorMsgConfig = Store.getState().errorData.errorMesgConfig;
    const apiEndPointName = apiUrl ? UtilityService.getEndpointName(apiUrl) : null;
    const errorConfig = errorMsgConfig[errorCode] || errorMsgConfig.default;
    const errorMessage = apiEndPointName
      ? errorConfig[apiEndPointName] || errorConfig.default
      : errorConfig.default;

    Store.dispatch({
      type: SHOW_API_ERROR,
      payload: errorMessage,
    });
  };
}

const HttpService = new HttpAPI();
Object.freeze(HttpService);

export default HttpService;
